import React, { useState } from 'react';
import useMantenimiento from '../../hooks/useMantenimiento';

import Icon from '../../commons/Icon';
import { mensajeMini } from '../../commons/Mensajes';
import { useFormularioContext } from '../../commons/Formulario';
import Loading from '../../commons/Loading';

import PhotosIcon from '../../assets/icons/photos.svg';
import BookIcon from '../../assets/icons/book.svg';
import RequestIcon from '../../assets/icons/file-request.svg';
import SuppliesIcon from '../../assets/icons/supplies.svg';
import TestIcon from '../../assets/icons/test-tube.svg';

import { solicitudModel } from '../../redux/models/solicitud.model';

import MaintenanceBook from './MaintenanceBook';
import MaintenanceEquipment from './MaintenanceEquipment';
import MaintenancePhotos from './MaintenancePhotos';
import MaintenanceResults from './MaintenanceResults';
import MaintenanceSave from './MaintenanceSave';
import MaintenanceSupplies from './MaintenanceSupplies';

const MaintenanceItem = (props) => {
  const { selected, dispatch, getData, cancelTransaction } =
    useFormularioContext();
  const { getEquipmentPrevius, getPhotos } = useMantenimiento();
  const [selectedEquipment, setSelectedEquipment] = useState(null);

  const [resultEquipment, setResultEquipment] = useState(null);
  const [photos, setPhotos] = useState();

  const [fieldsErrors, setFieldsErrors] = useState(undefined);
  const [processingEquipement, setProcessing] = useState(false);

  const [pageActive, setPageActive] = useState(0);

  const pages = [
    { title: 'Mantenimiento', icon: RequestIcon },
    { title: 'Resultados', icon: TestIcon },
    { title: 'Imagenes', icon: PhotosIcon },
    { title: 'Insumos', icon: SuppliesIcon },
    { title: 'Manuales', icon: BookIcon },
  ];

  const getEquipment = async (equipment) => {
    setProcessing(true);
    let response = await getEquipmentPrevius(equipment.eq.eq, selected.so);

    if (response.success && response.status === 'success') {
      setResultEquipment(response.result);
      handleGetPhotos(equipment);
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    } else {
      setFieldsErrors(response.fieldsErrors);
    }
    setProcessing(false);
  };

  const handleGetPhotos = async (equipment) => {
    let response = await getPhotos(selected.so, equipment.eq.eq);
    if (response.success && response.status === 'success') {
      setPhotos(response.result);
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    }
  };

  const handlePage = () => {
    switch (pageActive) {
      case 0:
        return (
          <MaintenanceSave
            equipment={selectedEquipment}
            previusEquipment={resultEquipment}
            onSave={(result) => {
              if (result === '000') {
                dispatch({ type: 'CLOSE_TASK' });
                cancelTransaction(solicitudModel);
                getData();
              } else {
                setPageActive(0);
                getEquipment(selectedEquipment);
              }
            }}
          />
        );
      case 1:
        return (
          <MaintenanceResults
            equipment={selectedEquipment}
            previusEquipment={resultEquipment}
            onSave={() => {
              setPageActive(0);
              getEquipment(selectedEquipment);
            }}
          />
        );
      case 2:
        return (
          <MaintenancePhotos
            photos={photos}
            equipment={selectedEquipment}
            onSave={() => {
              setPageActive(0);
              getEquipment(selectedEquipment);
            }}
          />
        );
      case 3:
        return (
          <MaintenanceSupplies
            equipment={selectedEquipment}
            previusEquipment={resultEquipment}
            onSave={() => {
              setPageActive(0);
              getEquipment(selectedEquipment);
            }}
          />
        );
      case 4:
        return <MaintenanceBook equipment={selectedEquipment} />;
      default:
        throw Error('Page not implemented');
    }
  };

  return (
    <>
      <div className="equipment-content">
        {selected.qq?.map((x) => (
          <MaintenanceEquipment
            key={x.eq?.eq}
            code={x.eq?.ce}
            name={x.eq?.ne}
            onClick={() => {
              setSelectedEquipment(x);
              getEquipment(x);
              setPageActive(0);
            }}
          />
        ))}
      </div>
      <div className="item-content">
        {selectedEquipment && (
          <>
            {processingEquipement && resultEquipment ? (
              <Loading />
            ) : (
              <>
                <span
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <small>{`${selectedEquipment.eq.ce} `}</small>
                  <strong>{selectedEquipment.eq.ne}</strong>
                </span>
                <div className="pages-header">
                  {pages.map((p, i) => (
                    <div
                      key={i}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => setPageActive(i)}
                    >
                      <Icon svg={p.icon} size={40} transparent />
                      <span>{p.title}</span>
                    </div>
                  ))}
                </div>
                {handlePage()}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

MaintenanceItem.propTypes = {};

export default MaintenanceItem;
